<template>
  <div class="main">
    <div class="tip">司机发布晚班拼车行程时，会向已订阅乘客推送通知。可在此查看并取消订阅。</div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-empty v-if="!loading && list.length === 0" description="暂无订阅的司机" />
      <div v-for="item in list" :key="item.UserId" class="driver-card">
        <div class="driver-info">
          <van-image width="44" height="44" round :src="item.Avatar" />
          <div class="driver-text">
            <div class="driver-name">{{ item.Name }}</div>
            <div class="driver-car">
              {{ item.CarNum || '未填车牌' }}
              <template v-if="item.CarBrand || item.CarName || item.CarColor">
                （{{ item.CarColor }}{{ item.CarBrand }}{{ item.CarName }}
                <template v-if="item.CarSeat"> | {{ item.CarSeat }}座</template>）
              </template>
            </div>
            <div class="driver-route" v-if="item.Route || item.Destination">
              <template v-if="item.Route">路线{{ item.Route }} · </template>
              {{ item.Origin || '公司' }} → {{ item.Destination || '-' }}
            </div>
            <a v-if="item.Phone" class="driver-phone" :href="'tel://' + item.Phone">{{ item.Phone }}</a>
          </div>
        </div>
        <van-button
          size="small"
          round
          color="#333333"
          :loading="item._cancelling"
          @click="onCancel(item)"
        >取消订阅</van-button>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      refreshing: false
    }
  },
  mounted() {
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const result = await this.$request({
          url: this.$api.getSubscribeList,
          method: 'GET',
          params: {
            UserId: this.WXInfo.userid
          }
        })
        if (result.success) {
          this.list = (result.data || []).map(item => Object.assign({}, item, { _cancelling: false }))
        } else {
          this.$toast(result.message || '获取订阅列表失败')
        }
      } finally {
        this.loading = false
        this.refreshing = false
      }
    },
    onRefresh() {
      this.getList()
    },
    onCancel(item) {
      this.$dialog.confirm({
        title: '取消订阅',
        message: '确定不再订阅司机[' + item.Name + ']的行程通知？'
      }).then(async () => {
        this.$set(item, '_cancelling', true)
        try {
          const result = await this.$request({
            url: this.$api.postCancelSubscribe,
            method: 'POST',
            data: {
              DriverId: item.UserId,
              UserId: this.WXInfo.userid
            }
          })
          if (result.success) {
            this.$toast('已取消订阅')
            this.list = this.list.filter(d => d.UserId !== item.UserId)
          } else {
            this.$toast(result.message || '取消失败')
          }
        } finally {
          this.$set(item, '_cancelling', false)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  min-height: 100%;
  background-color: #F5F5F5;
  padding: 12px;
}
.tip {
  font-size: 13px;
  color: #999999;
  line-height: 1.5;
  margin-bottom: 12px;
  padding: 0 4px;
}
.driver-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 14px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.driver-info {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  padding-right: 12px;
}
.driver-text {
  padding-left: 10px;
  line-height: 1.45;
  min-width: 0;
}
.driver-name {
  font-weight: 600;
  font-size: 15px;
}
.driver-car,
.driver-route,
.driver-phone {
  font-size: 12px;
  color: #999999;
  margin-top: 2px;
}
.driver-phone {
  color: #39A0F4;
  display: inline-block;
}
</style>
